import { z } from 'zod'

import { ApiRequestErrorNetwork } from './ApiRequestError'

const basicErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
})

const parseJson = z
  .string()
  .transform((str) => {
    try {
      return JSON.parse(str)
    } catch (e) {
      console.error(e)
      return null
    }
  })
  .pipe(basicErrorSchema)

export const parseApiRequestErrorCode = (error: unknown) => {
  if (!(error instanceof ApiRequestErrorNetwork)) return null

  const result = parseJson.safeParse(error.data.message)
  if (!result.success) return null

  return result.data.code
}
